import React, { Component } from 'react';
import { Col, Container } from 'reactstrap';
import Table from '../tables/Table';
import RenderRow from './renderRowQuestionnaire';
import { connect } from 'react-redux';
import { signout } from '../../redux/actions/userActions';
import controls from './conponents/vendor_questions'

class ResponsiveTable extends Component {
  state = {
    controls: controls.filter(control => control.category === this.props.selectedCatName.name),
    loading: true,
    loaded: false
  }

  render () {
    return (
      <Container>
        <Col md={12} lg={12}>
          {
            <Table responsive className={`table--bordered table`} dataCategory="Risk Assessment and Treatment">
                <thead>
                  <tr>
                    <th style={{
                      width: 73
                    }}>Questions</th>
                    <th style={{
                      width: 230
                    }}>Responses</th>
                    <th style={{
                      width: 250
                    }}>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.controls.length > 0 ?
                      renderControls(this.state.controls)
                      : null
                  }
                </tbody>
              </Table>
          }
        </Col>
      </Container>
    )
  }
}

const renderControls = (controls) => {

  return controls.map((control, i) => {
              return (
                <RenderRow
                  index={i}
                  control={control}
                  key={control.id}
                  defaultValue={3}
                />)
})}

export default connect(null, { signout })(ResponsiveTable);


// WEBPACK FOOTER //
// ./src/components/vendor_assessments/controlQuestionnaire.js